import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .industry-selection-wrapper {
    display: flex;
    justify-content: center;
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .industry-selection-wrapper {
    }
  }
`;
